
import { defineComponent, PropType, onUpdated, ref, computed } from 'vue'
import { View } from '@/models/view'
import { RouteRecordName, useRoute, useRouter } from 'vue-router'
import { NavigationItem } from './NavigationItem.vue'

export default defineComponent({
  name: 'NavigationDropDown',
  props: {
    values: {
      type: Object as PropType<NavigationItem['route'][]>,
      required: true
    },
    parent: {
      type: Object
    }
  },
  emits: ['click'],
  setup (props, { emit }) {
    const $router = useRouter()
    const $route = useRoute()
    const options = [...props.values.map((view) => ({label: view.meta?.title || view.name, value: view.name}))]


    const active = computed(() => props.values.find(view => view.name === $route.name))

    const currentView = computed<{label: string, value: RouteRecordName}>({
      get: () => ({label: active.value?.meta?.title as string || active.value?.name as string, value: active.value?.name as RouteRecordName}),
      set: (option) => {
        void $router.push({ name: option.value })
      }
    })

    // onUpdated(() => {
    //   emit(
    //     'click',
    //     props.values.filter((view) => view.name === currentView.value)[0]
    //   )
    // })

    return {
      active,
      currentView,
      options,
      contentWidth: computed(() => {
        return options.map(s => s.label as string).reduce((s,n) => s.length > n.length ? s : n,'').length * 10
      })
    }
  }
})
